import React, { useEffect } from 'react'
import { Box, Group, Badge, Text } from '@mantine/core'
import { useStore } from '../../stores/store'
import type { TagDto } from '../../models/tag'
import { TagCategory } from '../../models/tag'

const CATEGORY_LABELS: Record<number, string> = {
  [TagCategory.Platform]: 'Platform',
  [TagCategory.Caliber]: 'Caliber',
  [TagCategory.PartCategory]: 'Part type',
  [TagCategory.ReviewSentiment]: 'Sentiment',
  [TagCategory.ContentTopic]: 'Topic'
}

interface TagFilterChipsProps {
  selectedTagIds: string[];
  onToggleTag: (tagId: string) => void;
  /** Show only tags in these categories (default: all non-Internal). */
  categories?: number[];
}

export default function TagFilterChips ({
  selectedTagIds,
  onToggleTag,
  categories
}: TagFilterChipsProps) {
  const { tagStore } = useStore()
  const set = new Set(selectedTagIds)

  useEffect(() => {
    tagStore.loadTags()
  }, [])

  const tagsByCat = tagStore.tagsByCategory
  const cats = categories ?? [TagCategory.Platform, TagCategory.Caliber, TagCategory.PartCategory, TagCategory.ReviewSentiment, TagCategory.ContentTopic]

  return (
    <Box mb="md">
      <Text size="sm" weight={500} color="dimmed" mb="xs">
        Filter by tag
      </Text>
      {cats.map((cat) => {
        const tags = tagsByCat[cat] ?? []
        if (tags.length === 0) return null
        return (
          <Group key={cat} spacing="xs" mb="xs">
            <Text size="xs" color="dimmed" sx={{ minWidth: 72 }}>
              {CATEGORY_LABELS[cat] ?? 'Tags'}:
            </Text>
            {tags.map((t) => {
              const selected = set.has(t.id)
              return (
                <Badge
                  key={t.id}
                  size="sm"
                  variant={selected ? 'filled' : 'light'}
                  radius="sm"
                  sx={{ cursor: 'pointer' }}
                  rightSection={selected ? <span style={{ marginLeft: 4 }} onClick={(e) => { e.stopPropagation(); onToggleTag(t.id) }}>×</span> : undefined}
                  onClick={() => onToggleTag(t.id)}
                >
                  {t.displayName || t.name}
                </Badge>
              )
            })}
          </Group>
        )
      })}
    </Box>
  )
}
